/**
 * 🔒 A refusal a Settings screen shows is a sentence somebody can act on, and
 * never the server's own words about its own shape (decision 0603; the rule
 * decisions 0455 and 0483 wrote for labels, taken to banners). The product
 * owner met one of these on the Roles screen — *"This tells me nothing what
 * does this even mean this is a bad alarm or warning message"* — and three more
 * screens print server text into a banner the same way.
 *
 * 🔨 The page's own sentence always leads. The server's reason follows it only
 * where that reason reads as a sentence; a reason carrying a column name, a
 * type name or a key is dropped, because a person cannot act on it and it makes
 * the banner longer rather than clearer.
 */

/**
 * The shapes that say *this was written for a developer*: a camelCase
 * identifier, a generic type, a dotted key.
 *
 * 🔨 A brace is NOT one of them. A stage action's title template is written with
 * `{deal}` and `{customer}` in it, and the refusal naming a token a person typed
 * is the most useful sentence on that screen.
 */
const DEVELOPER_TEXT = /[a-z0-9][A-Z]|Record<|\b[a-z]+\.[a-z]+[A-Za-z.]*\b/;

/** True where the text reads as a sentence for the person in front of the screen. */
export function readsAsSentence(message: string): boolean {
  const text = message.trim();
  if (text.length === 0) return false;
  return !DEVELOPER_TEXT.test(text);
}

/**
 * The banner's text: the page's own sentence, and the server's reason after it
 * where the reason is one a person can read. 🔨 The two are joined with a space
 * and no punctuation is invented, so a server sentence keeps its own full stop.
 */
export function wordedRefusal(ownWording: string, message?: string | null): string {
  const text = (message ?? '').trim();
  if (text === '' || !readsAsSentence(text)) return ownWording;
  return text === ownWording ? ownWording : `${ownWording} ${text}`;
}
